module.exports = __webpack_public_path__ + "media/images/icon/jobs-fbcd97500d700807856aafe6ce8d764f.svg";